/* Spec tables in product descriptions, on phones.
   A table wider than the description column (Unior size charts, the WTB
   saddle chart) is re-laid out as stacked rows: each item becomes a block of
   "Label  value" lines taken from the header row, so the whole table reads
   top to bottom with no sideways scrolling. Tables that already fit are left
   alone. Styles: [data-ciclo-stack] in ciclo-base.css. A data attribute, not
   a class, so Dawn's table:not([class]) borders still apply. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');

  // Label every body cell from the header row. Only plain grids qualify:
  // a header row plus data rows of the same width, no merged cells.
  function prepare(table) {
    if (table.hasAttribute('data-ciclo-stackable')) {
      return table.getAttribute('data-ciclo-stackable') === 'yes';
    }
    var rows = table.rows;
    var width = rows.length ? rows[0].cells.length : 0;
    var ok = rows.length > 1 && width > 2;
    for (var i = 0; ok && i < rows.length; i++) {
      if (rows[i].cells.length !== width) ok = false;
      for (var j = 0; ok && j < rows[i].cells.length; j++) {
        if (rows[i].cells[j].colSpan > 1 || rows[i].cells[j].rowSpan > 1) ok = false;
      }
    }
    if (ok) {
      var labels = [];
      for (j = 0; j < width; j++) {
        labels.push(rows[0].cells[j].textContent.replace(/\s+/g, ' ').trim());
      }
      rows[0].setAttribute('data-ciclo-stack-head', '');
      for (i = 1; i < rows.length; i++) {
        for (j = 0; j < width; j++) rows[i].cells[j].setAttribute('data-label', labels[j]);
      }
    }
    table.setAttribute('data-ciclo-stackable', ok ? 'yes' : 'no');
    return ok;
  }

  function fit() {
    document.querySelectorAll('.product__description table').forEach(function (table) {
      var box = table.closest('.product__description');
      table.removeAttribute('data-ciclo-stack');
      if (!mq.matches || !box.clientWidth) return;
      if (table.offsetWidth > box.clientWidth + 1 && prepare(table)) {
        table.setAttribute('data-ciclo-stack', '');
      }
    });
  }

  var timer;
  function refit() {
    clearTimeout(timer);
    timer = setTimeout(fit, 150);
  }

  fit();
  window.addEventListener('resize', refit);
  if (mq.addEventListener) mq.addEventListener('change', fit);
})();
